import React from 'react';
import PropTypes from 'prop-types';

function AnalyticsTabs({ activeTab = 'transactions', onTabChange = () => {} }) {
  const tabs = [
    { id: 'transactions', label: 'Transactions' },
    { id: 'insights', label: 'User Insights' }
  ];

  return (
    <div className="card border-0 shadow-sm mb-4">
      <div className="card-body p-0">
        <ul className="nav nav-tabs border-0 px-4 pt-4">
          {tabs.map((tab) => (
            <li className="nav-item" key={tab.id}>
              <button 
                className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => onTabChange(tab.id)}
                style={{ 
                  color: activeTab === tab.id ? '#F89423' : '#6c757d',
                  borderBottom: activeTab === tab.id ? '3px solid #F89423' : 'none',
                  fontWeight: '600',
                  border: 'none',
                  backgroundColor: 'transparent'
                }}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

AnalyticsTabs.propTypes = {
  activeTab: PropTypes.string,
  onTabChange: PropTypes.func
};

export default AnalyticsTabs;